import { useEffect, useState } from "react";
import ApiServices from "../../config/ApiServices";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { hideLoader, showLoader } from "../../redux/actions/LoaderActions";
import Loader from "../../utils/Loader";
import { showModal } from "../../redux/actions/ModalActions";
import ModalManager from "../../Modals/ModalManager";
import { Link, useParams } from "react-router-dom";
import { handleItemsPerPageChange, handlePageChange } from "../../utils/PaginationUtilities";
import Trainer from "../../commonpage/Trainers";

export default function ManageAssignTrainer({ title }) {
  const [selectedTrainers, setSelectedTrainers] = useState([]);
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.loader.loading);
  const isOpen = useSelector((state) => state.modal.isOpen);
  const { batchId } = useParams();
  const [peoples, setPeoples] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [totalData, setTotalData] = useState(0);
  useEffect(() => {
    if (!isOpen) {
      dispatch(showLoader());
      ApiServices.apiRequest("getSingleBatch", { _id:batchId })
        .then((res) => {
          if (res.data.success) {
            setPeoples(res.data?.data);
            setTotalData(res.data.data?.trainerId?.length || 0);
            setTotalPages(Math.ceil(res.data.data?.trainerId?.length / itemsPerPage));
          } else {
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          toast.error(err?.message ? err?.message : "Something went wrong");
        })
        .finally(() => {
          dispatch(hideLoader());
        });
    }
  }, [isOpen, dispatch]);

  const changeStatusTrainer = ( trainerId) => {
    let data = {
      batchId: batchId,
      trainerId:trainerId,
      status: false,
    };
    dispatch(showModal("StatusModal", data, "removeTrainer", "removeTrainer"));
  };

  const handleCheckboxChange = (studentId) => {
    setSelectedTrainers((prevSelected) => {
      if (prevSelected.includes(studentId)) {
        return prevSelected.filter((id) => id !== studentId);
      } else {
        return [...prevSelected, studentId];
      }
    });
  };
  return (
    <>
      <div className="container">
        <div className="page-inner">
          {loading && !isOpen ? (
            <Loader />
          ) : (
            <>
              <div className="pt-2 pb-4">
                <div className="d-flex justify-content-between">
                  <h3 className="fw-bold mb-3">{title}</h3>
                  <button onClick={() => { dispatch(showModal("AssignTrainer")) }} className="btn btn-primary btn-round">
                      Assign Trainer
                    </button>
                </div>
              </div>
              <Trainer
              peoples={peoples}
              totalData={totalData}
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              handlePageChange={handlePageChange(setCurrentPage)}
              handleItemsPerPageChange={handleItemsPerPageChange(setItemsPerPage, setCurrentPage)}
              handleCheckboxChange={handleCheckboxChange}
              changeStatusTrainer={changeStatusTrainer}
              batchId={batchId}
              selectedTrainers={selectedTrainers}
              />
            </>
          )}
        </div>
      </div>
    </>
  );
}
